import Cookies from 'cookies';
import { IncomingMessage, ServerResponse } from 'http';
import JSCookies from 'js-cookie';
import { IRegister } from '../../models/interface/register';
import { ICurrentUser } from '../../models/interface/user';
import api from '../api';
import tokenService from './token';

export class AuthService {
  public async login(
    email: string,
    password: string
  ): Promise<ICurrentUser | null> {
    const { data: token } = await api.post('/pwa/auth/login', {
      email,
      password,
    });
    JSCookies.set('token', token.accessToken, { expires: 480 });
    api.defaults.headers.Authorization = `Bearer ${token.accessToken}`;
    return tokenService.decode<ICurrentUser>(token.accessToken);
  }

  public async loginWithGPID(gpId: string): Promise<ICurrentUser | null> {
    const { data: token } = await api.post('/pwa/auth/gpid-login', {
      gpId,
    });
    JSCookies.set('token', token.accessToken, { expires: 480 });
    JSCookies.set('isGPID', 'true', { expires: 480 });
    api.defaults.headers.Authorization = `Bearer ${token.accessToken}`;
    return tokenService.decode<ICurrentUser>(token.accessToken);
  }

  public register(model: IRegister): Promise<ICurrentUser | null> {
    return api.post('/pwa/registration/app', model);
  }

  public logout(): boolean {
    JSCookies.remove('token');
    JSCookies.remove('isGPID');
    delete api.defaults.headers.Authorization;
    return true;
  }

  public getUserFromToken(): [ICurrentUser | null, boolean] {
    const token = JSCookies.get('token');
    let isGPID = JSCookies.get('isGPID');
    if (!token) return [null, false];
    api.defaults.headers.Authorization = `Bearer ${token}`;
    return [tokenService.decode<ICurrentUser>(token), !!isGPID];
  }

  public getUserFromTokenServerSide(
    req: IncomingMessage,
    res: ServerResponse
  ): ICurrentUser | null {
    const cookies = new Cookies(req, res);
    const token = cookies.get('token');
    if (!token) return null;
    api.defaults.headers.Authorization = `Bearer ${token}`;
    return tokenService.decode<ICurrentUser>(token);
  }

  public async sendRecoveryPawssword(email: string): Promise<any> {
    return api.post('/pwa/auth/send-reset', { email });
  }

  public async resetPassword(
    token: string | undefined,
    password: string,
    confirmPassword: string
  ): Promise<any> {
    return api.post('/pwa/auth/reset-password', {
      token,
      password,
      confirmPassword,
    });
  }
}

const authService = new AuthService();
export default authService;
